export default "__VITE_ASSET__ceWAQJO$__"